import type { EventAddressDto } from "../../app/data/tribeSwaggerApi"

export const selectCoordinate = (
  address: EventAddressDto,
): [number, number] => {
  return [address.event_longitude, address.event_latitude]
}
